import { useDispatch, useSelector } from "react-redux";
import { addTrendingMovies } from "../store/slices/moviesSlice";
import { useEffect, useCallback } from "react";
import { API_OPTIONS } from "../utils/constants";
import { RootState } from "../store";

const useTrendingMovies = () => {
  const dispatch = useDispatch();
  const trendingMovies = useSelector((store: RootState) => store.movies.trendingMovies);

  const getTrendingMovies = useCallback(async () => {
    try {
      const data = await fetch(
        "https://api.themoviedb.org/3/trending/movie/week?page=1",
        API_OPTIONS
      );
      const json = await data.json();
      dispatch(addTrendingMovies(json.results));
    } catch (error) {
      console.error("Error fetching trending movies:", error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (!trendingMovies) getTrendingMovies();
  }, [trendingMovies, getTrendingMovies]);
};

export default useTrendingMovies;
